import { render, staticRenderFns } from "./OneChat.vue?vue&type=template&id=66512741&scoped=true&"
import script from "./OneChat.vue?vue&type=script&lang=js&"
export * from "./OneChat.vue?vue&type=script&lang=js&"
import style0 from "./OneChat.vue?vue&type=style&index=0&id=66512741&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66512741",
  null
  
)

export default component.exports